import React, { useState } from "react";
import moment from "moment";
import DateTimePicker from "./DateTimePicker";
import { isEmpty } from "lodash";

const CustomDatePicker = ({ type, filter, setFilter }) => {
  const toDate = (v) => (v ? new Date(v) : null);

  const handleFromChange = (dateObj) => {
    setFilter((prev) => ({
      ...prev,
      fromPeriod: moment(dateObj).format("YYYY-MM-DD HH:mm:ss"),
    }));
  };

  const handleToChange = (dateObj) => {
    setFilter((prev) => ({
      ...prev,
      toPeriod: moment(dateObj).format("YYYY-MM-DD HH:mm:ss"),
    }));
  };
  return isEmpty(type) ? (
    <li className="blockdis">
      <div className="webhide">
        <DateTimePicker
          onChange={handleFromChange}
          max={new Date()}
          timeInputId="startTime"
          value={toDate(filter?.fromPeriod)}
        />
      </div>{" "}
      to{" "}
      <DateTimePicker
        onChange={handleToChange}
        min={toDate(filter?.fromPeriod)}
        max={new Date()}
        timeInputId="endTime"
        value={toDate(filter?.toPeriod)}
      />
    </li>
  ) : (
    <li>
      <DateTimePicker
        onChange={handleFromChange}
        max={new Date()}
        timeInputId="startTime"
        value={toDate(filter?.fromPeriod)}
      />
      to <br />
      <DateTimePicker
        onChange={handleToChange}
        min={toDate(filter?.fromPeriod)}
        max={new Date()}
        timeInputId="endTime"
        value={toDate(filter?.toPeriod)}
      />
    </li>
  );
};

export default CustomDatePicker;
